import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import InteracBulkPayoutTransactionInfo from './InteracBulkPayoutTransactionInfo';
import useFetchInteracBulkPayoutTransaction from '@/hooks/useApi/useFetchInteracBulkPayoutTransaction';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
} & Omit<ComponentProps<typeof InteracBulkPayoutTransactionInfo>, 'transaction' | 'Notes'>;

export default function InteracBulkPayoutTransactionContainer({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
  ...props
}: TransactionProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { interacBulkPayoutTransaction, fetchInteracBulkPayoutTransaction } = useFetchInteracBulkPayoutTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchInteracBulkPayoutTransaction(TransactionID)
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = interacBulkPayoutTransaction;

  return (
    <div>
      {transaction && (
        <InteracBulkPayoutTransactionInfo
          transaction={transaction}
          Notes={Notes || ''}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
